import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {ThemeProvider} from './context/ThemeContext';
import './i18n';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/app.css';
import './assets/styles/premium.css';
import './assets/styles/refinements.css';

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider><App /></ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
